import { FC } from 'react'

import { FF, FormType, RadioGroup, Select, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const DebitCard: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review the debit card activity for international transactions and unknown merchant/vendor activity.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="debitCardActivityReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="debitCardActivityUnknown"
            children={(field) => (
              <FF
                field={field}
                label="Was there international or unknown merchant/vendor activity?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'Yes – See comments',
                        value: 'yes'
                      },
                      {
                        label: 'All Transactions Ok',
                        value: 'all_transactions'
                      },
                      {
                        label: 'No Transactions of this Type',
                        value: 'no_transactions'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="debitCardActivityUnknownAddressed"
            children={(field) => (
              <FF
                field={field}
                label="If noted, how was the activity addressed?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'N/A',
                        value: 'n/a'
                      },
                      {
                        label: 'Transactions cleared with communication to customer during review',
                        value: 'cleared'
                      },
                      {
                        label: 'Transactions added to Annual Review questions',
                        value: 'added'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="debitCardActivityComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
